import request from "@/utils/request";

export function contractLockRead(params) {
  return request({
    url: "/contractLock/read",
    method: "post",
    data: params
  });
}

export function ctrLockReadSuc(params) {
  return request({
    url: "/contractLock/suc",
    method: "post",
    data: params
  });
}

export function ctrLockReadFail(params) {
  return request({
    url: "/contractLock/fail",
    method: "post",
    data: params
  });
}

export function ctrLockReadPerSuc(params) {
  return request({
    url: "/contractLock/perSuc",
    method: "post",
    data: params
  });
}

export function passCheckReq(params) {
  return request({
    url: "/contractLock/passCheck",
    method: "post",
    data: params
  });
}

export function getContractDetail(params) {
  return request({
    url: "/sec/contractLock/getContractDetail",
    method: "post",
    data: params
  });
}

export function downloadFile(params) {
  return request({
    url: "/contractLock/downloadFile",
    method: "post",
    data: params
  });
}

export function createContractThumbnail(params) {
  return request({
    url: "/contractLock/createContractThumbnail",
    method: "post",
    data: params
  });
}

export function deleteContractThumbnail(params) {
  return request({
    url: "/contractLock/deleteContractThumbnail",
    method: "post",
    data: params
  });
}

export function changeStatusForApprove(params) {
  return request({
    url: "/v2/sec/contractDetail/changeStatusForApproveNomem",
    method: "post",
    data: params
  });
}

export function changeStatus(params) {
  return request({
    url: "/v2/sec/contractDetail/changeStatusNomem",
    method: "post",
    data: params
  });
}

export function changeStatusForReviewApprove(params) {
  return request({
    url: "/contractLock/changeStatusForReviewApprove",
    method: "post",
    data: params
  });
}

export function getFileHash(params) {
  return request({
    url: "/contractLock/getFileHash",
    method: "post",
    data: params
  });
}

export function NoMem(params) {
  return request({
    url: "/contractLock/noMemLogin",
    method: "post",
    data: params
  });
}

export function verifyChain(params) {
  return request({
    url: "/contractLock/verifyChain",
    method: "post",
    data: params
  });
}

export function getContractRecord(params) {
  return request({
    url: "/v2/sec/contractDetail/getContractRecord",
    method: "post",
    data: params
  });
}

export function approvalReviewNomem(params) {
  return request({
    url: "/v2/sec/contractDetail/approvalReviewNomem",
    method: "post",
    data: params
  });
}

export function approvalDestroyContractNomem(params) {
  return request({
    url: "/v2/sec/contractDetail/approvalDestroyContractNomem",
    method: "post",
    data: params
  });
}

export function uploadFile(params) {
  return request({
    url: "/contractLock/uploadFile",
    method: "post",
    data: params
  });
}

export function sendAttachFile(params) {
  return request({
    url: "/contractLock/sendAttachFile",
    method: "post",
    data: params
  });
}

export function approvalContractNomem(params) {
  return request({
    url: "/v2/sec/contractDetail/approvalContractNomem",
    method: "post",
    data: params
  });
}

export function rejectContractNomem(params) {
  return request({
    url: "/v2/sec/contractDetail/rejectContractNomem",
    method: "post",
    data: params
  });
}
